function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 0C19.6406 0 21 1.35938 21 3V18C21 19.6406 19.6406 21 18 21H3C1.35938 21 0 19.6406 0 18V3C0 1.35938 1.35938 0 3 0H18ZM10.5 13.5C9.65625 13.5 9 14.1562 9 15C9 15.8438 9.65625 16.5 10.5 16.5C11.3438 16.5 12 15.8438 12 15C12 14.1562 11.3438 13.5 10.5 13.5ZM10.5 4.5C9.65625 4.5 8.95312 5.25 9.04688 6.09375L9.375 10.9688C9.42188 11.5312 9.89062 12 10.5 12C11.1094 12 11.5781 11.5312 11.625 10.9688L11.9531 6.09375C12.0469 5.25 11.3438 4.5 10.5 4.5Z",
  fill: "#D32F2F"
});

function SvgCampaignError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignError);
export default __webpack_public_path__ + "static/media/campaign-error.462d3923.svg";
export { ForwardRef as ReactComponent };